import { render, staticRenderFns } from "./NotificationMessages.vue?vue&type=template&id=500d3f51&scoped=true&"
import script from "./NotificationMessages.vue?vue&type=script&lang=js&"
export * from "./NotificationMessages.vue?vue&type=script&lang=js&"
import style0 from "./NotificationMessages.vue?vue&type=style&index=0&id=500d3f51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500d3f51",
  null
  
)

export default component.exports